import { Component } from '@theme/component';

const TOP_THRESHOLD = 16;

class ApcHeader extends Component {
  #controller = null;
  #lastY = 0;
  #down = 0;
  #up = 0;
  #ticking = false;

  connectedCallback() {
    super.connectedCallback();
    if (!this.hasAttribute('data-hide-on-scroll')) return;
    this.#controller = new AbortController();
    this.#lastY = window.scrollY;
    window.addEventListener('scroll', this.#onScroll, { passive: true, signal: this.#controller.signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
    this.#controller = null;
  }

  #onScroll = () => {
    if (this.#ticking) return;
    this.#ticking = true;
    requestAnimationFrame(this.#update);
  };

  #update = () => {
    const y = window.scrollY;
    const delta = y - this.#lastY;

    if (delta > 0) {
      this.#down += delta;
      this.#up = 0;
    } else if (delta < 0) {
      this.#up -= delta;
      this.#down = 0;
    }

    const height = this.offsetHeight || 56;

    if (y < TOP_THRESHOLD) {
      this.removeAttribute('data-hidden');
      this.#down = 0;
      this.#up = 0;
    } else if (this.#down > height && !this.hasAttribute('data-hidden')) {
      this.setAttribute('data-hidden', '');
      this.#down = 0;
    } else if (this.#up > height / 3 && this.hasAttribute('data-hidden')) {
      this.removeAttribute('data-hidden');
      this.#up = 0;
    }

    this.#lastY = y;
    this.#ticking = false;
  };
}

if (!customElements.get('apc-header')) {
  customElements.define('apc-header', ApcHeader);
}
